<template>
  <!-- 自定义表单input -->
  <ACol :span="span" class="x-form-item" :class="mb0 && 'mb0'">
    <label class="x-form-item-label" :style="labelStyle">{{ label }}</label>
    <div class="x-form-item-symbol">{{ symbol }}</div>
    <div class="x-form-item-content">
      <AFormModelItem :prop="prop">
        <AInput v-bind="$attrs" @input="emitHandler" @blur="emitHandler"/>
      </AFormModelItem>
    </div>
    <div class="x-form-item-suffix">
    </div>
  </ACol>
</template>
<script>
export default {
  props:{
    /** 24等分宽度占比 */
    span: {
      type: Number,
      default: 8
    },
    /** 标签 */
    label: {
      default: '标签'
    },
    /** 标签宽度 */
    labelWidth: {
      type: Number,
      default: 70
    },
    /** 连接符 */
    symbol: {
      default: ":"
    },
    prop: String,
  },
  data(){
    return {
      
    }
  },
  computed:{
    labelStyle(){
      return {
        width: isNaN(this.labelWidth) ? this.labelWidth : `${this.labelWidth}px`
      }
    },
    mb0(){
      return this.$parent.$attrs.mb0
    }
  },
  created(){
  },
  methods:{
    emitHandler(e){
      this.$emit('input', e.target.value)
    }
  }
}
</script>
<style lang="less" scoped>
@margin-bottom: 24px;
.x-form-item{
  display: flex;
  align-items: center;
  & > * {
    margin-bottom: 24px;
  }
  &.mb0 > * {
    margin-bottom: 0px;
    .ant-form-item{
      margin-bottom: 0px;
    }
  }
  .x-form-item-label{
    text-align: right;
    line-height: 1.1;
  }
  .x-form-item-symbol{
    margin-right: 8px;
    margin-left: 3px;
  }
  .x-form-item-content{
    margin-bottom: 0;
    flex: 1;
  }
  .x-form-item-suffix{
    width: 20px;
  }
}
</style>